// Restrict homepage access based on environment type and rights
export const isHomepageAllowed = (route: string, environmentType: string, allowedRights: string[] = []) => {

    // The admin dashboard is exclusively for superusers, in every
    // environment, so regular users never see it anywhere
    if (route === '/admin-dashboard') {
        return allowedRights.includes('no_user');
    }

    // Admin environments can access all routes
    if (environmentType === 'admin') {
        return !['/trial-homepage'].includes(route);
    }

    // Trial environments can access all routes
    if (environmentType === 'trial') {
        return true;
    }

    // Beta environments cannot access the trial homepage
    if (environmentType === 'beta') {
        return !['/trial-homepage'].includes(route);
    }

    // Client users cannot access the trial homepage
    if (environmentType === 'client' || environmentType === 'demo') {
        return !['/trial-homepage'].includes(route);
    }

    // Api partner environments cannot access trial homepage and dashboard
    if (environmentType === 'api-partner') {
        return !['/trial-homepage', '/dashboard'].includes(route);
    }

    return false;
};
